module.exports = __webpack_public_path__ + "media/images/vector-28@2x-f442b871d16cf631990047ae9fea0fd2.png";